import React, {useCallback, useEffect, useRef, useState} from "react";
import validator from 'validator'
import {ReCAPTCHA} from "react-google-recaptcha";
import {v56a_register} from "./v56Api";
import V56spinner from "./v56Spinner";
import RegistrationFinished from "./registrationFinished";
import {
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import SignupErrorPage from "./signupErrorPage";

export default function V56Signup() {

    const [loading, setLoading] = useState(false);
    const [registered, setRegistered] = useState(false);
    const [error, setError] = useState('');
    const [signupError, setSignupError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [user, setUser] = useState('');
    const [pass, setPass] = useState('');
    const [enableSignup, setEnableSignup] = useState(false);

    const emailInput = useRef(null)

    const { executeRecaptcha } = useGoogleReCaptcha();

    // Create an event handler, so you can call the verification on button click event or form submit
    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        const token = await executeRecaptcha('yourAction');
        // Do whatever you want with the token
    }, [executeRecaptcha]);

    useEffect(() => {
        handleReCaptchaVerify();
    }, [handleReCaptchaVerify]);

    useEffect(() => {
        if (emailInput.current !== null) {
            emailInput.current.focus();
        }
    }, [])

    function validateEmail(e) {
        if (validator.isEmail(e)) {
            setEmailErrorMessage('');
        } else {
            setEmailErrorMessage('Enter a valid email address');
        }
    }

    async function doSignup() {
        await handleReCaptchaVerify();
        setLoading(true);
        setError('');
        setEmailErrorMessage('');
        setPasswordErrorMessage('');

        if (user.trim() === '' || !validator.isEmail(user)) {
            setLoading(false);
            setEmailErrorMessage('Enter a valid email address');
            return;
        }

        if (pass.trim() === '' || pass.length < 8) {
            setLoading(false);
            setPasswordErrorMessage('Enter a password (minimum 8 characters)');
            return;
        }

        const retVal = await v56a_register(
            user,
            'x',
            'x',
            pass,
            'x',
            'v56wp',
            'https://secure.vault56.com/validate_email'
        );
        setLoading(false);
        if (retVal.status === 201) {
            setRegistered(true);
        } else if (retVal.status === 400 && retVal.data['code'] === 4004 && retVal.data['parameter'] === 'email') {
            // Email already exist
            setEmailErrorMessage('This email is already registered');
        } else if (retVal.status === 400 && retVal.data['code'] === 4002) {
            // Validation error
            setLoading(false);
            if (retVal.data['parameter'] === 'email') {
                setEmailErrorMessage('Enter a valid email address');
            } else if (retVal.data['parameter'] === 'first_name') {
                setEmailErrorMessage('Enter your first name');
            } else if (retVal.data['parameter'] === 'last_name') {
                setEmailErrorMessage('Enter your last name');
            } else if (retVal.data['parameter'] === 'password') {
                setPasswordErrorMessage('Enter a password (minimum 8 characters)');
            }
        } else {
            // Unknown error
            setRegistered(false);
            setLoading(false);
            setSignupError(true);
        }
    }

    function onKeyDown(e) {
        if (e.key.toString() === "Enter") {
            doSignup();
        }
    }

    function enableSignupDb(value) {
        setEnableSignup(true);
    }


    if (loading) {
        return(
            <V56spinner/>
        )
    } else if (signupError) {
        return (
            <SignupErrorPage/>
        )
    } else if (registered) {
        return (
            <RegistrationFinished/>
        )
    } else {
        return (
            <>
                <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">

                    <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 space-y-6">
                            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                                <img
                                    className="mx-auto h-12 w-auto"
                                    src="https://cdn.vault56.com/images/56_logo.png"
                                    alt="vault56"
                                />
                                <h2 className="mt-6 text-center text-2xl font-extrabold text-gray-900">Create vault56 account</h2>
                                <div className="mt-2 text-center text-sm text-gray-600 underline">No credit card or purchase required</div>
                            </div>
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                    Email address
                                </label>
                                <div className="mt-1">
                                    <input
                                        ref={emailInput}
                                        onKeyDown={(e) => onKeyDown(e)}
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        disabled={loading}
                                        onChange={(e) => {
                                            validateEmail(e.target.value);
                                            setUser(e.target.value);
                                        }}
                                        required
                                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#5f2881] focus:border-[#5f2881] sm:text-sm"
                                    />
                                </div>
                                <span style={{color: 'red'}}>{emailErrorMessage}</span>
                            </div>

                            <div>
                                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                    Password
                                </label>
                                <div className="mt-1">
                                    <input
                                        id="password"
                                        onKeyDown={(e) => onKeyDown(e)}
                                        name="password"
                                        type="password"
                                        autoComplete="current-password"
                                        disabled={loading}
                                        onChange={(e) => {
                                            setPass(e.target.value);
                                        }}
                                        required
                                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#5f2881] focus:border-[#5f2881] sm:text-sm"
                                    />
                                </div>
                                <span style={{color: 'red'}}>{passwordErrorMessage}</span>
                            </div>

                            <span style={{color: 'red'}}>{error}</span>

                            <ReCAPTCHA
                                sitekey="6LcVoYQfAAAAAPHDDHzUgp_q1UywxwhmjVLcwUt4"
                                onChange={(e) => enableSignup(e)}
                            />

                            <div>
                                <button
                                    onClick={() => doSignup()}
                                    disabled={(emailErrorMessage !== '' && passwordErrorMessage !== '') || enableSignup}
                                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#5f2881] hover:bg-[#6f4488] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    Create Account and Start Free Trial
                                </button>
                            </div>

                            <div className="text-center">
                                Already have an account?{' '}
                                <a href="https://secure.vault56.com">
                                    Login
                                </a>
                            </div>

                            <div className="text-xs text-gray-500">By creating an account you consent to the terms in our <a href="https://vault56.com/download/vault56_ca.pdf" target="_blank">customer agreement (PDF)</a> and our <a href="https://vault56.com/download/vault56_baa.pdf" target="_blank">business account agreement (PDF)</a></div>

                            <div className="text-center">
                                <a href="https://www.vault56.com">
                                    Go to vault56.com
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </>
        )
    }
}
